import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * Selector de rango temporal de Planificación Avanzada: semanal, mensual o anual.
 * El modo se guarda en la URL (`?vista=semanal|mensual|anual`) para que sea
 * direccionable y para que tanto el wrapper de la ruta como la página lean la
 * misma fuente de verdad. Los filtros se comparten entre los modos (store).
 */
export const PLAN_VISTAS = ['semanal', 'mensual', 'anual'] as const

export type PlanVista = typeof PLAN_VISTAS[number]

export function readVista(params: URLSearchParams): PlanVista {
  const v = params.get('vista')
  return PLAN_VISTAS.includes(v as PlanVista) ? (v as PlanVista) : 'semanal'
}

export function ViewModeSelect({ dark }: { dark: boolean }) {
  const { t } = useTranslation()
  const [params, setParams] = useSearchParams()
  const vista = readVista(params)

  return (
    <select
      value={vista}
      onChange={(e) =>
        setParams(
          (p) => {
            p.set('vista', e.target.value)
            return p
          },
          { replace: true },
        )
      }
      title={t('planning.viewMode.label')}
      className={`text-[11px] px-2.5 py-1.5 rounded-lg border transition-colors font-medium cursor-pointer outline-none ${
        dark
          ? 'border-white/10 bg-white/5 text-slate-300 hover:bg-white/10 focus:border-sky-500'
          : 'border-slate-200 bg-white text-slate-500 hover:bg-slate-50 shadow-sm focus:border-sky-400'
      }`}
    >
      <option value="semanal">{t('planning.viewMode.weekly')}</option>
      <option value="mensual">{t('planning.viewMode.monthly')}</option>
      <option value="anual">{t('planning.viewMode.yearly')}</option>
    </select>
  )
}
